import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FileUploadModule} from 'ng2-file-upload';

import {ToggleFullscreenDirective} from './fullscreen/toggle-fullscreen.directive';
import {AccordionAnchorDirective} from './accordion/accordionanchor.directive';
import {AccordionLinkDirective} from './accordion/accordionlink.directive';
import {AccordionDirective} from './accordion/accordion.directive';
import {CardRefreshDirective} from './card/card-refresh.directive';
import {CardToggleDirective} from './card/card-toggle.directive';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ScrollModule} from './scroll/scroll.module';
import {MenuItems} from './menu-items/menu-items';
import {DataFilterPipe} from './element/data-filter.pipe';
import {DataRegExpFilterPipe} from './element/data-regexp-filter.pipe';
import {SpinnerComponent} from './spinner/spinner.component';
import {CardComponent} from './card/card.component';
import {ModalAnimationComponent} from './modal-animation/modal-animation.component';
import {ModalBasicComponent} from './modal-basic/modal-basic.component';
import { UploadComponent } from './upload/upload.component';
import {HttpModule} from '../lib/interceptor/interceptor.module';

import { RequestProvider } from '../lib/provider/request';
import { SelectDataProvider } from '../lib/provider/select_data';
import { RegionProvider } from '../lib/provider/region';
import { UploadSimpleComponent } from './upload-simple/upload-simple.component';

@NgModule({
  imports: [
    CommonModule,
    ScrollModule,
    NgbModule.forRoot(),
    FileUploadModule,
    HttpModule
  ],
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ToggleFullscreenDirective,
    CardRefreshDirective,
    CardToggleDirective,
    SpinnerComponent,
    CardComponent,
    ModalAnimationComponent,
    ModalBasicComponent,
    DataFilterPipe,
    DataRegExpFilterPipe,
    UploadComponent,
    UploadSimpleComponent
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ToggleFullscreenDirective,
    CardRefreshDirective,
    CardToggleDirective,
    ScrollModule,
    NgbModule,
    SpinnerComponent,
    CardComponent,
    ModalAnimationComponent,
    ModalBasicComponent,
    DataFilterPipe,
    DataRegExpFilterPipe,
    UploadComponent,
    UploadSimpleComponent,
    HttpModule
  ],
  providers: [
    MenuItems,
    RequestProvider,
    SelectDataProvider,
    RegionProvider
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// /Users/liyankai/Documents/github/seiya_web.git/src/app/shared/shared.module.ts